export enum FlowNodeTypes {
  CONTENT = 'content',
  DEFAULT = 'default',
  PUSH = 'push',
  START = 'start',
  TARGET_AUDIENCE = 'targetAudience',
  WEBHOOK = 'webhook',
}
